// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2HQNj","title":"InfoRow_title__3UdaV"};